import React from 'react';

const CrashPlanWithText = () => {
  return (
    <svg
      width="180"
      height="28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="CrashPlan logo"
    >
      <g clipPath="url(#a)">
        <path
          d="M39.5 7.9h-3v19.7H0V0h13.6l4.2 4h12l-5 3.9h-8.5l-4.3-4H4v19.8h28.6V7.9h-3l5-4 4.9 4Z"
          fill="#09B2E0"
        />
        <path
          d="M44.3 13.8c0-4.5 3.4-7.7 7.8-7.7 3 0 4.9 1.6 6 3.4l-2.2 1.1A4.4 4.4 0 0 0 52 8.4c-3 0-5 2.3-5 5.4 0 3.1 2 5.4 5 5.4 1.6 0 3-1 3.8-2.2l2.2 1.2a6.7 6.7 0 0 1-6 3.3 7.5 7.5 0 0 1-7.8-7.7ZM69.8 21.2l-3.3-5.5h-2.6v5.5h-2.6V6.4h6.5c3 0 4.9 1.9 4.9 4.6 0 2.7-1.8 4.1-3.5 4.4l3.6 5.8h-3ZM70 11c0-1.4-1-2.3-2.5-2.3h-3.6v4.7h3.6c1.4 0 2.5-1 2.5-2.4ZM86.8 21.2l-1.1-2.8h-6.8l-1.1 2.8h-3l5.9-14.8h3.2l5.8 14.8h-3ZM82.3 9l-2.7 7H85l-2.7-7ZM91.3 19.1l1.4-2c1 1.1 2.7 2 4.7 2 2.2 0 3-1 3-2 0-1.3-1.6-1.7-3.4-2.2-2.4-.6-5.2-1.3-5.2-4.4 0-2.5 2.1-4.3 5.4-4.3 2.3 0 4.2.7 5.5 2l-1.5 2A6 6 0 0 0 97 8.5c-1.5 0-2.5.7-2.5 1.8 0 1.2 1.5 1.5 3.3 2 2.5.6 5.4 1.4 5.4 4.6 0 2.5-1.8 4.6-5.8 4.6a8 8 0 0 1-6-2.4ZM116.9 21.2v-6.5h-7.7v6.5h-2.6V6.4h2.6v6h7.7v-6h2.6v14.8H117ZM123.8 21.2V6.4h6.5c3.1 0 4.8 2.1 4.8 4.6 0 2.5-1.7 4.7-4.8 4.7h-4v5.5h-2.5Zm8.7-10.2c0-1.4-1-2.3-2.6-2.3h-3.5v4.7h3.5c1.5 0 2.6-1 2.6-2.4ZM138.4 21.2V6.4h2.6v12.5h6.6v2.3h-9.2ZM161.4 21.2l-1-2.8h-6.9l-1 2.8h-3l5.8-14.8h3.3l5.8 14.8h-3ZM157 9l-2.6 7h5.3L157 9ZM177.5 21.2l-7.8-10.6v10.6h-2.6V6.4h2.7l7.6 10.3V6.4h2.6v14.8h-2.5Z"
          fill="#173A64"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h180v27.6H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CrashPlanWithText;
